import { useState } from 'react';

import { TIdVerificationPerson } from '@helpers/FundingRequirements/fundingRequirements.types';

import { IdCheckSmsSent } from './IdCheckSmsSent';
import { SendIdCheckSms } from './SendIdCheckSms';

type TSent = {
    personUid: string;
    number: string;
    status: TIdVerificationPerson['status'];
};

export const MultiplePeopleIdCheck = ({
    people
}: {
    people: TIdVerificationPerson[];
}) => {
    const [sent, setSent] = useState<TSent>();
    const [sendingAgainUid, setSendingAgainUid] = useState<string>();
    const sentPerson = sent && people.find(({ uid }) => uid === sent.personUid);

    // Sending moves them to in_review; anything after that means they're done or failed.
    if (sent && sentPerson && sentPerson.status !== sent.status) {
        setSent(
            sentPerson.status === 'in_review'
                ? { ...sent, status: sentPerson.status }
                : undefined
        );
    }

    if (sent && sentPerson) {
        return (
            <IdCheckSmsSent
                name={`${sentPerson.first_name} ${sentPerson.last_name}`}
                sentNumber={sent.number}
                onResend={() => {
                    setSendingAgainUid(sentPerson.uid);
                    setSent(undefined);
                }}
            />
        );
    }

    return (
        <SendIdCheckSms
            people={people}
            sendingAgainUid={sendingAgainUid}
            onSent={({ personUid, phone }) => {
                const person = people.find(({ uid }) => uid === personUid);
                if (person) {
                    setSent({
                        personUid,
                        number: phone.number,
                        status: person.status
                    });
                }
                setSendingAgainUid(undefined);
            }}
        />
    );
};
